import React, { useState } from 'react';
import { IconButton, Tooltip, Badge } from '@mui/material';
import { useErrorLogs } from '../../status/StatusContext';
import Error from '@mui/icons-material/Error';
import ErrorLogListDialog from './ErrorLogListDialog';
import { useHasPermission } from '../../permission/PermissionUtil';

const squareHighlightStyle = {
    width: '45px',
    height: '45px',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0',
    padding: '0',
};

export default function ErrorLogButton() {

    const [showErrorLogDialog, setShowErrorLogDialog] = useState(false);

    const openErrors = () => {
        setShowErrorLogDialog(true);
    };

    const hasViewErrorsPermission = useHasPermission("Logs:Error:View");
    const errorLogCount = useErrorLogs();

    if (!hasViewErrorsPermission) {
        return null;
    }

    return (
        <>
            {showErrorLogDialog && <ErrorLogListDialog onClose={() => setShowErrorLogDialog(false)} />}
            <IconButton
                size="large"
                type='button'
                onClick={openErrors}
                color="inherit"
                style={squareHighlightStyle}
            >
                <Badge badgeContent={errorLogCount} color="error">
                    <Tooltip title='Error Log'>
                        <Error />
                    </Tooltip>
                </Badge>
            </IconButton>
        </>
    );
}
